import React from 'react';
import Component from '@vfuk/core-search-input';
const SearchInput = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default SearchInput;
